import LoadingComponent from './loading'
import Vue from 'vue'
let instance;

const loadingConstructor = Vue.extend(LoadingComponent)

instance = new loadingConstructor({
    el:document.createElement('div')
})

instance.show = true;

const loading = {
    show(options= '') {
        instance.show = true;
        document.body.style.overflow = "hidden"
        document.body.style.height = "100%"
        document.documentElement.style.overflow = 'hidden'
        document.documentElement.style.height = '100%'
        document.body.appendChild(instance.$el)
        if (options) {
            instance.text = options
        }
    },
    hide() {
        document.body.style.overflow = "visible"
        document.body.style.height = "auto"
        document.documentElement.style.overflow = 'visible'
        document.documentElement.style.height = 'auto'
        instance.text = ''
        instance.show = false;
        if(document.getElementsByClassName("loading")&&document.getElementsByClassName("loading").length>0)
        {
            for(var i=0;i<document.getElementsByClassName("loading").length;i++)
            {
                document.getElementsByClassName("loading")[i].style.display="none";
            }
        }
    }
}

export default {
    install() {
        if(!Vue.$loading) {
            Vue.$loading = loading
        }
        Vue.mixin({
            created() {
                this.$loading = Vue.$loading
            }
        })
    }
}